(function () {
    'use strict';

    /**
     * Dummy Module to include the generated template-caches by gulp !!!
     */
    var module = angular.module('uwAgenda.templates', ['uwAgenda.global']);   

})();